import { createAction } from '@reduxjs/toolkit';

import * as ActionTypes from './actionTypes';

export const loadBackOfficeLink = createAction(
  ActionTypes.LOAD_BACK_OFFICE_LINK.BASE,
);
